import { Link } from "react-router-dom";
import { useTranslation } from "../i18n/i18n";
import AppHeader from "../components/AppHeader/AppHeader";
import LoginForm from "../components/AuthForm/LoginForm";

const Login = () => {
	const { translate } = useTranslation();

	return (
		<div className="content auth-page-container legacy-auth">
			<AppHeader />
			<LoginForm />
			<h2 className="application-description">
				{translate("login.noAccount")}
			</h2>
			<Link to="/register" className="primary-button">
				{translate("login.signupLink")}
			</Link>
		</div>
	);
};

export default Login;
